// Vue
import { Component, Prop, Vue } from "vue-property-decorator";
// Template
import template from "./template.vue";
import InlineSVG from "../../../../components/inline_svg/InlineSVG";
import { ProductFilterBranche } from "../../../../common/interfaces/conversionworld/ProductFilter";

@Component({
  mixins: [template],
  components: {
    InlineSVG,
  },
})
export default class Branchen extends Vue {
  @Prop({ default: false })
  public useKonsiFilter!: boolean;

  get filterStore() {
    if (this.useKonsiFilter) {
      return this.$store.conversionWorldKonsiFilter;
    }

    return this.$store.conversionWorldProductFilter;
  }

  get branchen() {
    if (this.filterStore.filterData) {
      return this.filterStore.filterData.branchen.filter((x) => x.count > 0);
    }

    return [];
  }

  private isChecked(branche: ProductFilterBranche) {
    return this.filterStore.filter.branchen.indexOf(branche.id) >= 0;
  }

  private onInput(branche: ProductFilterBranche, value) {
    if (value) {
      if (!this.isChecked(branche)) {
        this.filterStore.addFilterTag("branchen", branche);
      }
    } else {
      this.filterStore.removeFilterTag("branchen", branche);
    }
  }
}
